import React, { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, TableSortLabel, Divider } from '@mui/material';
import { Product, ProductFilterData } from 'models';
import { TableErrorMessage, TableLoadingBar, TablePaginationFooter, ProductFilterPane, ProductRow, ProductForm, TableEmptyRow } from 'components';
import { useProducts, useTableContext } from 'hooks';

export const ProductTable = () => {
	const { products, isFetching, error, filterFunction } = useProducts();
	const {
		visibleData,
		page,
		rowsPerPage,
		order,
		orderBy,
		handlePageChange,
		handleChangeRowsPerPage,
		filterData,
		setFilterData,
		handleSort
	} = useTableContext<Product, ProductFilterData>({ data: products, filterFunction })
	return (
		<>
			<ProductFilterPane filterData={filterData} setFilterData={setFilterData} />
			<Divider />
			<TableContainer component={Paper} style={{ display: 'flex' }}>
				<Table aria-label='collapsible table'>
					<TableHead>
						<TableRow>
							<TableCell colSpan={1} />
							<TableCell colSpan={2}>
								<TableSortLabel active={orderBy === 'name'} direction={orderBy === 'name' ? order : 'asc'} onClick={() => handleSort('name')} />
								Name
							</TableCell>
							<TableCell colSpan={4}>
								<TableSortLabel active={orderBy === 'basePrice'} direction={orderBy === 'basePrice' ? order : 'asc'} onClick={() => handleSort('basePrice')} />
								Base Price
							</TableCell>
							<TableCell colSpan={4}>
								<TableSortLabel active={orderBy === 'bonusPoints'} direction={orderBy === 'bonusPoints' ? order : 'asc'} onClick={() => handleSort('bonusPoints')} />
								Bonus Points
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{isFetching && <TableLoadingBar colSpan={10} />}
						{error && <TableErrorMessage error={error} colSpan={10}></TableErrorMessage>}
						{!isFetching && visibleData && (
							<>
								<TableEmptyRow formComponent={<ProductForm />} />
								{visibleData.map((row: Product) => (
									<ProductRow key={row.id} row={row} />
								))}
							</>
						)}
					</TableBody>
				</Table>
			</TableContainer>
			<TablePaginationFooter totalRows={products?.length ?? 0} page={page} rowsPerPage={rowsPerPage} handlePageChange={handlePageChange} handleChangeRowsPerPage={handleChangeRowsPerPage} />
		</>
	);
}